export default "__VITE_ASSET__WyCgQfxs__"